import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=0e8d1aac&scoped=true&"
import script from "./BlogCard.vue?vue&type=script&lang=js&"
export * from "./BlogCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=0e8d1aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d1aac",
  null
  
)

export default component.exports